import { Typography } from '@mui/material';

export default function Header({ children }) {
    return (
        <Typography variant='body1' color='secondary' className='my-3 [word-spacing:5px] md:[word-spacing:10px] lg:[word-spacing:20px] leading-loose' component='div'>
            {children}
        </Typography>
    );
}
